export default {"src":"/_next/static/media/dwg-icon.442dc8ca.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};